export default __webpack_public_path__ + "static/media/certificacion_avanzada.d3e2427b.svg";